<script setup lang="ts">
import { ExclamationCircleIcon } from '@heroicons/vue/24/outline';
import ButtonG from '@/modules/shared/components/ButtonComponent.vue';

defineProps({
    title: {
        type: String,
        required: true
    },
    text: {
        type: String,
        required: true
    },
    textButton: {
        type: String,
        required: true
    }
});
</script>

<template>
    <!-- Connection issues -->
    <tbody class="border border-b! border-gray-200">
        <tr>
            <td class="bg-white" colspan="5">
                <div class="p-10 flex flex-col justify-center items-center">
                    <div class="p-3.5 bg-orange-100 rounded-full">
                        <ExclamationCircleIcon class="w-5 h-5 text-orange-600" />
                    </div>
                    <p class="text-gray-900 text-base leading-6 font-medium pt-2">{{ title }}</p>
                    <p class="text-gray-500 text-sm leading-5 w-1/3 m-auto text-center pt-1">{{ text }}</p>
                    <div class="p-6 flex gap-2 justify-center">
                        <ButtonG type-color="bg-gray" text="Contact support" class="w-36!" />

                        <ButtonG :text="textButton" class="w-32!" />
                    </div>
                </div>
            </td>
        </tr>
    </tbody>
</template>

<style scoped></style>
